import clsx from "clsx";
import PropTypes from "prop-types";

// Presentational wrapper used to group a settings subsection (Organization
// "Allmänt"/SSO/Vårdenhet cards, etc.) behind a bordered, rounded card with
// an icon + title header and an optional right-aligned actions slot.
// Rounding/border visual language matches CustomModal's own card surface.
const SettingsCard = ({ icon: Icon, title, actions, children, className }) => (
  <div
    className={clsx(
      "rounded-xl border border-solid border-silver-md-light bg-milk p-8 mb-8",
      className,
    )}
  >
    <div className="flex flex-row items-center justify-between mb-6">
      <div className="flex flex-row items-center">
        {Icon && (
          <div className="w-10 h-10 rounded-full bg-pampas flex items-center justify-center mr-4 shrink-0">
            <Icon className="w-5 h-5 text-dawn-gray" />
          </div>
        )}
        <h3 className="text-2xl text-dawn-gray font-medium-poppins">
          {title}
        </h3>
      </div>
      {actions && <div className="flex items-center shrink-0">{actions}</div>}
    </div>
    <div>{children}</div>
  </div>
);

SettingsCard.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.node,
  actions: PropTypes.node,
  className: PropTypes.string,
};

export default SettingsCard;
